import { ColumnFiltersState } from '@tanstack/react-table';

export const DEFAULT_PAGE_SIZE = 10;
export const EMPTY_COLUMN_FILTERS: ColumnFiltersState = [];
